import Parse from 'html-react-parser';

function BMP20226(props) {
    let svgCode =
    `<svg width="284" height="272" viewBox="0 0 284 272" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="284" height="272" fill="${props.envBG}"/>
        <line x1="143" y1="4.37114e-08" x2="143" y2="272" stroke="${props.fontColour}" stroke-opacity="0.5" stroke-width="2"/>
        <line x1="71" y1="4.37114e-08" x2="71" y2="272" stroke="${props.fontColour}" stroke-opacity="0.25" stroke-width="2"/>
        <line x1="213" y1="4.37114e-08" x2="213" y2="272" stroke="${props.fontColour}" stroke-opacity="0.25" stroke-width="2"/>
        <line x1="283" y1="4.37114e-08" x2="283" y2="272" stroke="${props.fontColour}" stroke-opacity="0.1" stroke-width="2"/>
        <line x1="1" y1="4.37114e-08" x2="0.999988" y2="272" stroke="${props.fontColour}" stroke-opacity="0.1" stroke-width="2"/>
        <line y1="137" x2="284" y2="137" stroke="${props.fontColour}" stroke-opacity="0.5" stroke-width="2"/>
        <line y1="205" x2="284" y2="205" stroke="${props.fontColour}" stroke-opacity="0.25" stroke-width="2"/>
        <line y1="69" x2="284" y2="69" stroke="${props.fontColour}" stroke-opacity="0.25" stroke-width="2"/>
        <line y1="1" x2="284" y2="1" stroke="${props.fontColour}" stroke-opacity="0.1" stroke-width="2"/>
        <line y1="271" x2="284" y2="271" stroke="${props.fontColour}" stroke-opacity="0.1" stroke-width="2"/>
    </svg>`

    props.svgReturn(82, svgCode, "bmp00226", 284, 272);

    const style = {
        position: "absolute",
        overflow: "hidden",
        height: "500px",
        top: "824px",
        left: "1505px",
        display: props.display
    }

    const inStyle = {
        marginTop: "0"
    }

    return (
        <div style={style}>
            <div style={inStyle}>
            {Parse(svgCode)}
            </div>
        </div>
    );
}

export default BMP20226;